import React, { useEffect, useRef } from 'react';
import styles from './ServicesSection.module.css';

const services = [
  ['AI Automations', 'Save hours, eliminate manual work, scale on autopilot.'],
  ['Funnel Design', 'Capture and convert leads and your sales, on repeat.'],
  ['CRM Builds', 'No more lost leads. See every customer, every time.'],
  ['Ad Scaling', 'Double your returns. Spend smart, grow faster.'],
  ['Lead Generation', 'Your ideal clients, delivered. Stop chasing, start attracting.'],
  ['Content Strategy', 'Your message, everywhere. Stand out, be remembered.'],
  ['Social Media Systems', 'Grow, influence, and engage without burning out.'],
  ['Retention Engines', 'Turn one-time buyers into lifelong fans.'],
  ['UGC Management', 'Let creators fuel your growth, hands-free.'],
];

function ServicesSection() {
  const cardsRef = useRef([]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const inner = entry.target.querySelector(`.${styles.flipCardInner}`);
              if (inner && !inner.classList.contains(styles.flipped)) {
                inner.classList.add(styles.flipped);
              }
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 }
      );

      cardsRef.current.forEach((card) => {
        if (card) observer.observe(card);
      });

      return () => {
        cardsRef.current.forEach((card) => {
          if (card) observer.unobserve(card);
        });
      };
    }
  }, []);

  return (
    <section className={styles.servicesSection} id="services">
      <h2 className={styles.sectionTitle}>What We Deliver</h2>
      <p className={styles.sectionSubtext}>Custom solutions built to scale you up</p>

      <div className={styles.servicesGrid}>
        {services.map(([front, back], index) => (
          <div
            key={index}
            className={styles.flipCard}
            ref={(el) => (cardsRef.current[index] = el)}
          >
            <div className={styles.flipCardInner}>
              <div className={styles.flipCardFront}>{front}</div>
              <div className={styles.flipCardBack}>{back}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServicesSection;
